import { toast } from "react-toastify";

export const mapInvoiceDataToForm = (invoiceData, setFieldValue, setProductSections, setIntraState) => {
  if (!invoiceData) return;

  console.log("Mapping invoice data to form:", invoiceData);
  
  // Map supplier information
  if (invoiceData.supplier) {
    if (invoiceData.supplier.name) {
      setFieldValue("fullName", invoiceData.supplier.name);
    }
    if (invoiceData.supplier.gst) {
      setFieldValue("gstNumber", invoiceData.supplier.gst);
    }
    if (invoiceData.supplier.address) {
      setFieldValue("address", invoiceData.supplier.address);
    }
    if (invoiceData.supplier.phone) {
      setFieldValue("supplierMobile", invoiceData.supplier.phone);
    }
  }

  // Map invoice dates
  if (invoiceData.invoiceDate) {
    setFieldValue("intimationDate", invoiceData.invoiceDate);
  }
  
  if (invoiceData.dueDate) {
    setFieldValue("expectedDate", invoiceData.dueDate);
  }

  // Map invoice number
  if (invoiceData.invoiceNumber) {
    setFieldValue("refInvoiceNo", invoiceData.invoiceNumber);
  }

  // Map products/items
  if (invoiceData.items && Array.isArray(invoiceData.items) && invoiceData.items.length > 0) {
    const mappedProducts = invoiceData.items.map((item, index) => ({
      productName: item.name || `Item ${index + 1}`,
      quantity: parseFloat(item.quantity) || 1,
      purchasePrice: parseFloat(item.unitPrice) || 0,
      discount: parseFloat(item.discount) || 0,
      igst: parseFloat(item.igst) || 0,
      cgst: parseFloat(item.cgst) || 0,
      sgst: parseFloat(item.sgst) || 0,
      cess: parseFloat(item.cess) || 0,
      hsnNumber: item.hsn || "",
      finalPrice: parseFloat(item.total) || (parseFloat(item.quantity) * parseFloat(item.unitPrice)) || 0,
      discountUnit: item.discountType || "%",
      otherFee: 0,
      ean: generateHexTimeId(),
      sku_number: generateEanId(),
      hasVariants: false,
      variantType: "size",
      variantConfig: {
        color: ["Red", "Blue", "Green", "Black", "White"],
        size: ["S", "M", "L", "XL"],
        model: [],
        custom: []
      },
      variants: []
    }));

    setProductSections(mappedProducts);
    
    // Determine transaction type based on GST
    const hasIGST = invoiceData.items.some(item => parseFloat(item.igst) > 0);
    const hasCGST_SGST = invoiceData.items.some(item => 
      parseFloat(item.cgst) > 0 || parseFloat(item.sgst) > 0
    );
    
    if (hasIGST && !hasCGST_SGST) {
      setIntraState(false); // Interstate
    } else if (hasCGST_SGST && !hasIGST) {
      setIntraState(true); // Intrastate
    }
    
    toast.success(`Successfully filled ${mappedProducts.length} item(s) from invoice!`);
  } else {
    toast.info("Invoice processed, but no products found. Please check the invoice format.");
  }
};

// Helper functions
const generateHexTimeId = () => {
  return Date.now().toString(16) + Math.random().toString(16).substr(2, 8);
};

const generateEanId = () => {
  return Math.floor(Math.random() * 10000000000000).toString();
};